var jcrop_api = null;

$(function(){

	// upload photo to modal and initialize image cropper
	var inputEls = $('.form-photo input[type="file"]');
	for(var i = 0; i < inputEls.length; i++) {

		(function(){
			var inputEl 	      = $(inputEls[i]);
			var wrapperEl       = inputEl.closest('.form-photo');
			var photoEl         = wrapperEl.find('.form-photo__photo img');
			var popupEl         = $('[data-popup="image_upload"]');
			var aspectRatio     = +inputEl.attr('data-aspect-ratio') ? +inputEl.attr('data-aspect-ratio') : 1;
			var submitEl     		= popupEl.find('.popup-upload-image__submit .btn');
			var hiddenX      		= wrapperEl.find('.form-photo__x');
			var hiddenY      		= wrapperEl.find('.form-photo__y');
			var hiddenWidth  		= wrapperEl.find('.form-photo__width');
			var hiddenHeight 		= wrapperEl.find('.form-photo__height');
			var triggerEl				= wrapperEl.find('.form-photo__trigger');

			// on change upload image
			inputEl.on('change', function(){
				var thisEl = $(this);
				var maxMB  = +thisEl.attr('data-max-mb') ? +thisEl.attr('data-max-mb') : 10;

				// clear crop image and add it. Do it to reset jCrop
				var cropImageWrapEl = popupEl.find('.popup-upload-image__image');
				var cropImageEl  		= cropImageWrapEl.html('').html('<img />').find('img');

				// disable submit button
				submitEl.prop('disabled', true).addClass('disabled');

				// if there are files
				var file = this.files[0]
				if(file) {
					// if image is too big
					if(file.size > maxMB * 1024 * 1024) {
						alertify.error('Максимально допустимый размер фото ' + maxMB + 'МБ');
						return;
					}


					var imageReg = /\/(jpg|jpeg|png)$/i;

					// if file is image
					if(imageReg.test(file.type)){
						// add to imagesFiles
						imagesFiles[imagesIndex] = file;

						// add imageIndex to submitBtn
						submitEl.attr('data-image-index', imagesIndex);

						// increase imagesIndex
						imagesIndex++;

						// add image preview to crop
						var reader = new FileReader();
				    reader.onload = function (e) {
							cropImageEl.attr('src', e.target.result);
							cropImageEl.on('load', function(){
								var imgEl = $(this);
					    	window.openPopup(popupEl);

								var width 			= imgEl.width();
								var height 			= imgEl.height();
								var minWidth 		= 50;
								var minHeight		= 50;
								var minSize 		= [width < minWidth ? width : minWidth, height < minHeight ? height : minHeight];
								var setSelect 	= [0, 0];

								if(height * aspectRatio > width) {
									setSelect = [Math.floor(width / 2), Math.floor(height / 2), width, height / aspectRatio];
								}
								else {
									setSelect = [Math.floor(width / 2), Math.floor(height / 2), height, height * aspectRatio];
								}

								// initialize image cropper
					    	imgEl.Jcrop({
					    		boxWidth: width,
					    		aspectRatio: aspectRatio,
					    		setSelect: setSelect,
					    		minSize: minSize,
					    		bgColor: '',
					    		onChange: function(coordinates){
					    			submitEl.attr('data-x', coordinates.x > 0 ? coordinates.x : 0);
					    			submitEl.attr('data-y', coordinates.y > 0 ? coordinates.y : 0);
					    			submitEl.attr('data-width', coordinates.x2 - coordinates.x);
					    			submitEl.attr('data-height', coordinates.y2 - coordinates.y);
					    			submitEl.attr('data-area-width', cropImageEl.width());
					    			submitEl.attr('data-area-height', cropImageEl.height());
					    			submitEl.prop('disabled', false).removeClass('disabled');
					    		}
					    	});

				    		// submit cropped image to image field
								submitEl.on('click', function(){
									var thisEl 	= $(this);

									// get coordinates
									var x 				 = +thisEl.attr('data-x');
									var y 				 = +thisEl.attr('data-y');
									var width 		 = +thisEl.attr('data-width');
									var height  	 = +thisEl.attr('data-height');
									var areaWidth  = +thisEl.attr('data-area-width');
									var areaHeight = +thisEl.attr('data-area-height');
									var imageIndex = +thisEl.attr('data-image-index');

									// set image index
									photoEl.attr('data-upload-image', true);
									photoEl.attr('data-image-index', imageIndex);

									// get result width, height, x, y
									photoEl.prop('style', '');
									var photoWidth   = photoEl.width();
									var photoHeight  = photoEl.height();
									
									// set cropped image
									photoEl.attr('src', e.target.result);
									getImgSize(e.target.result, function(actualWidth, actualHeight){
										// fix Jcrop coordinates based on area and actual image width
										var trueWidth  = width * actualWidth / areaWidth;
										var trueHeight = height * actualHeight / areaHeight;
										var trueX  = x * actualWidth / areaWidth;
										var trueY  = y * actualHeight / areaHeight;

										// calculate result width, height, x, y
										var resultWidth 	= actualWidth * photoWidth / trueWidth;
										var resultHeight 	= actualHeight * photoHeight / trueHeight;
										var resultX       = trueX * photoWidth / trueWidth;
										var resultY   		= trueY * photoHeight / trueHeight;

										// set result props
										photoEl.css('width', resultWidth);
										photoEl.css('height', resultHeight);
										photoEl.css('margin-left', -resultX);
										photoEl.css('margin-top', -resultY);

										// set coordinates
										hiddenX.val(trueX);
										hiddenY.val(trueY);
										hiddenWidth.val(trueWidth); 
										hiddenHeight.val(trueHeight);

										// trigger change
										triggerEl.trigger('change');

										// close popup
										closePopup(popupEl);
									});
								});

							});
				    };
						reader.readAsDataURL(file);
					}
				}

				// clear input
				$(this).data('files', Object.assign({}, this.files));
				$(this).data('value', this.value);
				this.value = null;
				this.files = null;
			});
		})();
	}
});

// get actual height and width of image
function getImgSize(imgSrc, callback) {
  var newImg = new Image();

  newImg.onload = function() {
    callback(newImg.width, newImg.height);
  }

  newImg.src = imgSrc; // this must be done AFTER setting onload
}